import React, { useEffect, useState } from 'react';

interface SolarEclipseBrandProps {
    className?: string;
    onAnimationComplete?: () => void;
}

const SolarEclipseBrand: React.FC<SolarEclipseBrandProps> = ({ className = "" }) => {
    // Letter configs
    const letters = [
        { char: 'S', waveDelay: 0.15 },
        { char: 'L', waveDelay: 0.1 },
        { char: 'U', waveDelay: 0.2 },
        { char: 'N', waveDelay: 0.3 },
        { char: 'N', waveDelay: 0.4 },
    ];

    const letterStyle: React.CSSProperties = {
        opacity: 1,
        transform: 'scale(1)',
        filter: 'brightness(1.2) contrast(1.1) drop-shadow(0 0 0.1em rgba(34,211,238,0.3))',
        transition: 'none',
        WebkitBackgroundClip: 'text',
        willChange: 'transform', // Opt-in for GPU compositing
    };

    const textGradientClass = "relative text-[1.1em] bg-clip-text text-transparent bg-gradient-to-r from-cyan-200 via-purple-400 to-cyan-200 bg-[length:200%_auto] animate-nebula-flow animate-pulse-subtle";

    return (
        <div
            className={`relative flex items-center justify-center overflow-hidden p-[0.8em] ${className}`}
            aria-hidden="true"
        >
            <div className="relative flex items-center gap-[0.05em] z-10 font-black tracking-widest leading-none">
                {/* S */}
                <span
                    className={textGradientClass}
                    style={letterStyle}
                >
                    S
                </span>

                {/* O (The Eclipse) */}
                <div className="relative w-[0.8em] h-[0.8em] flex items-center justify-center mx-[0.1em]">
                    {/* The Sun (Cyan Glow) */}
                    <div className="absolute inset-0 rounded-full bg-cyan-400 blur-[0.15em] opacity-100 scale-110 shadow-[0_0_0.8em_rgba(34,211,238,0.6)]" />

                    {/* The Moon (The Mask) - Perfect Totality */}
                    <div className="absolute inset-0 rounded-full bg-black z-20" />

                    {/* The Corona Ring */}
                    <div className="absolute inset-0 rounded-full border-[0.04em] border-white/50 shadow-[0_0_0.5em_rgba(34,211,238,0.4)] z-30 opacity-100" />
                </div>

                {/* LUNN */}
                <div className="flex gap-[0.05em]">
                    {letters.slice(1).map((item, idx) => (
                        <span
                            key={idx}
                            className={textGradientClass}
                            style={letterStyle}
                        >
                            {item.char}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SolarEclipseBrand;
